module.exports = __webpack_public_path__ + "static/media/celabrate_red.9792112b.png";